module.exports = __webpack_public_path__ + "static/media/dashboard.42236aef.svg";